module.exports = __webpack_public_path__ + "img/prepack-laptop.523caf5b.png";